// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/1.2.0/js/" + chunkId + "." + {"vendors-node_modules_brightcove_react-player-loader_dist_brightcove-react-player-loader_es_js-5b6014":"016f123c","pages-ReservationList":"c2cfdc45"}[chunkId] + ".chunk.js";
};